/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Entry_MonthInputs */

const en_us2_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last month`)
};

const pt_br2_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês passado`)
};

const es_419_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes pasado`)
};

const pt_pt2_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês passado`)
};

const fr_fr2_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois dernier`)
};

const de_de2_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Monat`)
};

const it_it2_progress_report_entry_month = /** @type {(inputs: Progress_Report_Entry_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese scorso`)
};

/**
* | output |
* | --- |
* | "Last month" |
*
* @param {Progress_Report_Entry_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_entry_month = /** @type {((inputs?: Progress_Report_Entry_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Entry_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_entry_month(inputs)
	if (locale === "es-419") return es_419_progress_report_entry_month(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_entry_month(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_entry_month(inputs)
	if (locale === "de-DE") return de_de2_progress_report_entry_month(inputs)
	if (locale === "it-IT") return it_it2_progress_report_entry_month(inputs)
	return en_us2_progress_report_entry_month(inputs)
});
export { progress_report_entry_month as "progress-report.entry_month" }